module.exports = __webpack_public_path__ + "static/img/sm1.34ccd2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm1.png
// module id = cxyp
// module chunks = 1